import { errorToast } from 'common/components/toastNotification'

export const showInvalidFormToast = () =>
  errorToast('Please complete all necessary fields before saving.')
